import { useSubscription } from '@meraki-internal/state';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { DrawerLabel } from '../../components/drawer/DrawerLabel.tsx';
import { DrawerFieldText } from '../../components/drawer/DrawerFieldText.tsx';
import { Location } from './Location.tsx';
import { MissionTimes } from '../../missions/components/MissionTimes.tsx';
import { MissionTimesEditor } from '../../missions/components/MissionTimesEditor.tsx';
import { EditableMissionState } from '../../mission/model/EditableMissionState.ts';
import { MapViewModel } from '../model/MapViewModel.ts';
import { FlightChecklist } from '../../flight-checklist/FlightChecklist.tsx';
import { RefreshTimer } from '../../components/refresher/RefreshTimer.tsx';
import { DrawerButtons } from '../../components/drawer/DrawerButtons.tsx';
import { Button } from '../../components/button/Button.tsx';
import { FlightChecklistDrawerLabel } from '../../components/drawer/FlightChecklistDrawerLabel.tsx';
import { HistoryViewModel } from '../../app/HistoryViewModel.ts';
import { useBreakpoints } from '../../support/hooks/useBreakpoints.tsx';

// TODO: can reload map on view mission map page
// TODO: rename MissionSummaryMapDrawer
export const ViewMissionOnMapDrawer = ({ mission: vm, isEditingTimes = false }: { mission: EditableMissionState, isEditingTimes?: boolean }) => {
    const history = useInstance(HistoryViewModel);

    useSubscription(() => vm);
    const mapViewModel = useInstance(MapViewModel);
    useSubscription(() => mapViewModel);

    // need padding if drawer on side
    const { isLargerScreen } = useBreakpoints();
    const paddingTop = (isLargerScreen ? 50 : undefined);

    return (
        <div data-id="view-mission-drawer" style={{paddingTop}}>

            <RefreshTimer getIntervalMs={vm.getAutoRefreshIntervalMs} handler={vm.refresh} />

            <DrawerLabel text="Location" />
            <DrawerFieldText dataSet={{type: 'location'}}><Location mission={vm} /></DrawerFieldText>

            <DrawerLabel text="Flight Info" />
            {isEditingTimes &&
                <MissionTimesEditor mission={vm} source='Mission Area and Time' />
            }
            {!isEditingTimes &&
                <MissionTimes mission={vm} />
            }

            <DrawerLabel text="Max Altitude" />
            <DrawerFieldText dataSet={{type: 'altitude'}}>{vm.getMaxAltitude()}&nbsp;ft</DrawerFieldText>

            <FlightChecklistDrawerLabel />
            <FlightChecklist mission={vm} />

            <DrawerButtons>
                <Button color="secondary" fill="outline" dataType="back-button" onClick={() => history.back(vm.pages.details.path())}>Back</Button>
            </DrawerButtons>
        </div>
    );
};
